var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        { staticClass: "pa-0" },
        [
          _c(
            "v-tabs",
            {
              attrs: {
                dark: "",
                centered: "",
                color: "indigo",
                "slider-color": "cyan"
              },
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            },
            [
              _c(
                "v-tab",
                { attrs: { href: "#tab-1" } },
                [
                  _c("v-icon", [_vm._v("person")]),
                  _vm._v("Estructura organizacional\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab",
                { attrs: { href: "#tab-2" } },
                [_c("v-icon", [_vm._v("person")]), _vm._v("Personas ")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab",
                { attrs: { href: "#tab-3" } },
                [_c("v-icon", [_vm._v("domain")]), _vm._v("Unidades ")],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            },
            [
              _c(
                "v-tab-item",
                { attrs: { value: "tab-1" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      !!_vm.dependencia_superior
                        ? _c("ArbolUnidades", {
                            attrs: {
                              dependencia_superior: _vm.dependencia_superior
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { attrs: { value: "tab-2" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      !!_vm.dependencia_superior
                        ? _c("SliderPersonas", {
                            attrs: { filtros: _vm.filtros }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tab-item",
                { attrs: { value: "tab-3" } },
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      !!_vm.dependencia_superior
                        ? _c("EstructuraOrganizacional", {
                            attrs: { filtros: _vm.filtros }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8608f006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8608f006","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes_lista_personal/ListaPersonalActivo.vue
// module id = null
// module chunks = 